import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/PartnersPage.head';
import { PartnersPage } from '@pages/PartnersPage';

export const Route = createFileRoute('/partners')({
  component: PartnersPage,
  head: () => head,
});
